<template>
    <div class="game-page">
      <iframe
        name="iframe1"
        :srcdoc="isHttp ? null : $store.state.iframeURL"
        :src="isHttp ? $store.state.iframeURL : null"
        class="game-page__frame"
      ></iframe>
      <div class="game-page__bar">
        <van-dropdown-menu direction="up">
          <van-dropdown-item ref="item">
            <div style="padding: 5px 30px;" class="d-flex justify-content-between">
              <van-button color="linear-gradient(to right, #1e1e1e, #000000)" block round @click="$router.push('/home')">
                  <span class="my-auto mt-2">နောက်ပြန်သွားမည်။</span>
              </van-button>
              <van-button color="linear-gradient(to right, #ff6034, #ee0a24)" block round @click="$router.push('/deposit')">
                <span class="my-auto pt-1">ငွေဖြည့်ရန်။</span>
              </van-button>
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
      </div>
    </div>
</template>
<script>

export default {
  data(){
    return {
      value1: 'Pragmatic',
      option1: [
        { text: 'Deposit', value: 'Deposit' },
      ],
    }
  },
  async mounted() {
    if (!this.$store.state.iframeURL) {
      this.$router.push('/home');
      return;
    }
    this.lockPageScroll();
  },
  beforeDestroy() {
    this.unlockPageScroll();
  },
  computed: {
    isHttp() {
      const url = this.$store.state.iframeURL;
      if (!url || typeof url !== 'string') return false;
      return url.startsWith('http') || url.startsWith('blob:');
    }
  },
  methods: {
    lockPageScroll() {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    },
    unlockPageScroll() {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  }
};
</script>
<style scoped>
.game-page {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  z-index: 1000000;
  background: #000;
}
.game-page__frame {
  display: block;
  width: 100%;
  height: calc(100% - 3vh);
  border: none;
  background: #000;
}
.game-page__bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000001;
  height: 3vh;
}
</style>
